/* Esternal */
import { call, all } from "redux-saga/effects";

/* Actions */
import { baseActionName } from "./actions";

/* Services */
import { backendService } from "../../services";

/* Utils */
import { makeFetchSaga } from "../../utils";
import { TIME_ZONE } from "../../utils";

/* Constants */
const STATIONS_LANGUAGE = "*";
const STATIONS_REGION = TIME_ZONE;
const STATIONS_COUNT = 100;

function* fetchAllStations(language, region, count) {
  let offset = 0,
    stationsFetched = 0,
    allStations = [];

  do {
    let response;
    try {
      response = yield call(backendService.content.getStations, { language, region, count, offset });
    } catch (e) {
      // when station data is blank, normally for offset >= 100
      response = {};
    } finally {
      const { data = [] } = response;
      offset += count;
      stationsFetched = data.length;
      allStations = allStations.concat(data);
    }
  } while (stationsFetched >= count);

  return { data: allStations };
}

const fetchAllStationsSaga = makeFetchSaga(baseActionName, {
  func: fetchAllStations,
  getParams: () => [STATIONS_LANGUAGE, STATIONS_REGION, STATIONS_COUNT]
});

export default function* allStations() {
  yield all([fetchAllStationsSaga]);
}
